import Ease from '@CS/utils/Easing';
import styled, { css } from 'styled-components';

export const SCROLL_DURATION = 250;

type WeeksContainerAttributes = {
  $animate?: boolean;
};

export const WeeksContainer = styled.nav<WeeksContainerAttributes>(
  ({ $animate }) => css`
    backface-visibility: hidden;
    margin: 0 auto 1.25rem;
    transform-origin: 50%;

    display: inline-flex;
    align-items: center;

    position: relative;
    align-self: start;

    width: auto;
    gap: 5px;

    ${$animate &&
    css`
      transition-timing-function: ${Ease.InOut.Sine};
      transition-duration: ${SCROLL_DURATION}ms;
      transition-property: transform;
      transition-delay: 0s;
    `}
  `
);
